import RPopconfirm from "./RPopconfirm";

export default RPopconfirm